import { useFormik } from "formik";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Flip, toast, ToastContainer } from "react-toastify";
import { ResendVerificationCode } from "../../Api/ResendVerificationCode";
import { SignUp as SignUpAction, VerificationCodeApi } from "../../Api/SignUp";
import TextFiled from "../../components/common/InputField/TextFiled";
import MainButton from "../../components/common/MainButton/MainButton";
import PasswordField from "../../components/common/PasswordField/PasswordField";
import Spinner from "../../components/common/Spinner";
import Popup from "../../components/popup/Popup";
import { POPUP_FORM_CONTENT_CLASS } from "../../components/popup/popupLayoutSpec";
// import VerificationPopUp from "../../sections/VerificationPop/VerificationPopUp";
import Heading from "../../components/common/Typography/Heading";
import SecondaryHeading from "../../components/common/Typography/SecondaryHeading";
// import { MultiSelect } from "primereact/multiselect";
import Paragraph from "../../components/common/Typography/Paragraph";
// import Stepper from "../../components/common/StepIndicater/Stepper";
import { setField, setStep, resetSignUp } from "../../Redux/Slice/SignUp";
import {
  validationSchema
} from "../../FormValidations/SignUpSchema";
import useAuth from "../../Hooks/useAuth";
// import "./style.css";
import { useEffect } from "react";
// import { Dropdown } from "primereact/dropdown";
// import Snippet from "../../components/common/SnippetIcon/Snippet";
import AuxiliaryText from "../../components/common/Typography/AuxiliaryText";
import SpecialText from "../../components/common/Typography/SpecialText";
import Verify from "./EmailVerification/Verify";
import CustomerInfo from "./Customer/CustomerInfo";
import BusinessInfo from "./Business/BusinessInfo";
import InteractiveText from "../../components/common/Typography/InteractiveText";
import WrittenStepper from "../../components/common/StepIndicater/WrittenStepper";
import Alerts from "../../components/common/Alerts/Alerts";
// import InteractiveText from "../../components/common/Typography/InteractiveText";

import { SendOtpMutation, UpdateUserMutation } from "../../services/SignUp";
import { useGraphQL } from "../../context/GraphQLProvider";
import StepBackButton from "../../components/common/StepBackButton/StepBackButton";
import InlineError from "../../components/common/InlineError/InlineError";
import { transformToUserInput } from "../../utils/userInputUtils";
import { disableScroll, enableScroll } from "../../utils/scrollUtils";

// Add bypass button component
const BypassButton = ({ currentStep, userType, onBypass, showEmailField, showPasswordField }) => {
  const getNextStep = () => {
    // Handle different flows based on user type and current step
    if (currentStep === 1) {
      // Step 1 has sub-steps
      if (!showEmailField && !showPasswordField) {
        return "email"; // Show email field
      } else if (showEmailField && !showPasswordField) {
        return "password"; // Show password field
      } else if (showPasswordField) {
        return 2; // Move to email verification
      }
    } else if (currentStep === 2) {
      return 3; // Move to account type selection
    } else if (currentStep === 3) {
      return 4; // Move to personal/business details
    } else if (currentStep === 4) {
      return 5; // Move to next step (location for customer, select service for business)
    } else if (currentStep === 5) {
      if (userType === USER_TYPE.CUSTOMER) {
        return 6; // Customer: move to profile picture
      } else {
        return 6; // Business: move to primary skills
      }
    } else if (currentStep === 6) {
      if (userType === USER_TYPE.CUSTOMER) {
        return 7; // Customer: move to profile preview
      } else {
        return 7; // Business: move to location
      }
    } else if (currentStep === 7) {
      if (userType === USER_TYPE.CUSTOMER) {
        return null; // Customer: end of flow
      } else {
        return 8; // Business: move to profile picture
      }
    } else if (currentStep === 8) {
      if (userType === USER_TYPE.CUSTOMER) {
        return null; // Customer: end of flow
      } else {
        return 9; // Business: move to profile preview
      }
    } else if (currentStep === 9) {
      return null; // Business: end of flow
    }
    return null;
  };

  const nextStep = getNextStep();
  
  if (!nextStep) return null; // Don't show button on final step

  const getButtonText = () => {
    if (nextStep === "email") return "Skip → Email";
    if (nextStep === "password") return "Skip → Password";
    return `Skip → Step ${nextStep}`;
  };

  return (
    <button
      onClick={() => onBypass(nextStep)}
      className="fixed bottom-4 left-4 z-[999] bg-red-500 hover:bg-red-600 text-white px-3 py-2 rounded-lg text-sm font-medium shadow-lg transition-colors duration-200"
      title="Bypass validation and go to next step"
    >
      {getButtonText()}
    </button>
  );
};

const USER_TYPE = {
  CUSTOMER: "customer",
  SELLLER: "seller",
};
const LOGIN_SOURCE = {
  GMAIL: "Gmail",
  FACEBOOK: "Facebook",
  MANUAL: "Manual",
};
export const SignUp = ({ SignUpState, setSignUpState, SignIn, setSignIn }) => {
  const graphqlService = useGraphQL();
  const dispatch = useDispatch();
  const InitialValues = useSelector((state) => state.signup);
  const { id, email, password } = useSelector((state) => state.signup);
  // console.log('reduxstate');
  // console.log(useSelector((state) => state.signup));
  // console.log('reduxstate');
  // console.log('-------------------');
  // console.log('usestate');
  // console.log(InitialValues);
  // console.log('usestate');

  const [EmailVerificationStatus, setEmailVerificationStatus] = useState(false);
  const [ShowCrossButton, setShowCrossButton] = useState(true);
  // const [validCaptcha, setValidCaptcha] = useState(false);
  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";
  const [UserType, setUserType] = useState(null);
  const [popup, setPopup] = useState("A");
  const [PasswordType, setPasswordType] = useState("true");
  const [showEmailField, setShowEmailField] = useState(false);
  const [showPasswordField, setShowPasswordField] = useState(false);
  const [emailStep, setEmailStep] = useState(false);
  const [passwordStep, setPasswordStep] = useState(false);
  // const [RepeatPasswordType, setRepeatPasswordType] = useState("true");
  const [VerificationCode, setVerificationCode] = useState();
  const [userDetail, setUserDetail] = useState([{}]);
  const [ResendCode, setResendCode] = useState({
    isCodeSent: false,
  });
  const [VerificationError, setVerificationError] = useState({
    isError: false,
    errorMessage: null,
    isCodeExpire: false,
  });
  const { auth } = useAuth();
  const [RequestStart, setRequetStart] = useState(false);
  const { step } = useSelector((state) => state.signup);

  // const UpdateSignUpState = (Values) => {
  //     try {
  //         dispatch(setField(Values));
  //         console.log(useSelector((state) => state.signup));
  //         // return response;
  //     } catch (error) {
  //         console.error("Redux Error:", error);
  //         throw error;
  //     }
  // };

  const formik = useFormik(
    {
      initialValues: InitialValues,
      validationSchema: validationSchema,
      onSubmit: (values, { resetForm }) => {
        setRequetStart(true);
        // console.log(values);
        dispatch(setField(values));
        const email = values.email;
        // console.log(values);
        // UpdateSignUpState(values);
        // console.log(useSelector((state) => state.signup).email);
        // const splitUserName = values.username.split(" ");
        // const firstName = splitUserName?.[0];
        // const lastName = splitUserName?.[1] ?? firstName;

        // if (!validCaptcha) {
        //   setRequetStart(false);
        //   toast.error("reCAPTCHA required!", {
        //     position: toast.POSITION.TOP_RIGHT,
        //     transition: Flip,
        //   });
        // } else {

        // const SignUpUser = {
        //   FirstName: values.email,
        //   LastName: values.email,
        //   UserName: values.email,
        //   Email: values.email,
        //   ConfirmationCode: values.code,
        //   Password: values.password,
        //   ConfirmPassword: values.password,
        //   Source: LOGIN_SOURCE.MANUAL,
        //   EmailVerified: false,
        //   Role: UserType,
        // };
        // const SignUpUser = {
        //   Email: values.email,
        //   Password: values.password,
        // };

        SendOtpMutation(graphqlService, {
          email,
        })
        .then((response) => {
            if (response.sendOtp === 'OTP sent successfully'){
              dispatch(setStep(2));
              setRequetStart(false);
              formik.resetForm();
            }
        })
        .catch((error) => {
          Alerts.error(error);
        })
        .finally(() => {
          // dispatch(setStep(2));
          setRequetStart(false);
        });
        // setStep(2);
        // setRequetStart(false);

          // .finally(() => {
          //     setLoading(false);
          // });

        // SignUpAction(SignUpUser)
        //   .then((response) => {
        //     if (response.status === 200) {
        //       setRequetStart(false);
        //       const accessToken = response?.data?.token;
        //       const roles = response?.data?.userRoles?.$values;
        //       const user = response?.data?.key;
        //       const expireAt = response?.data?.tokenExpire;
        //       const subscription = response?.data?.matrix?.user?.subscription;
        //       const userDetails = {
        //         accessToken,
        //         roles,
        //         user,
        //         expireAt,
        //         subscription,
        //       };
        //       console.log("Check", userDetails);
        //       setUserDetail(userDetails);
        //       setPopup("D");
        //       setShowCrossButton(true);
        //       setEmailVerificationStatus(!EmailVerificationStatus);

        //       formik.resetForm();
        //     }
        //   })
        //   .catch((error) => {
        //     console.log("error", error);
        //   });
      },
    }
    // }
  );

  const UpdateUserType = (gql, userType) => {
    setRequetStart(true);
    const userInput = transformToUserInput(InitialValues);
    userInput.userInput.roleType = userType;

    UpdateUserMutation(gql, userInput)
      .then((response) => {
        if (response.updateUserProfile?.roleType === userType) {
          dispatch(setField({ roleType: userType }));
          dispatch(setStep(4));
        }
      })
      .catch((error) => {
        Alerts.error(error);
      })
      .finally(() => {
        // dispatch(setStep(4));
        setRequetStart(false);
      });
  };

  function VerifyVerificationCodeHandle() {
    setRequetStart(true);
    // console.log("Check", userDetail);
    if (!VerificationCode) {
      setRequetStart(false);
      setVerificationError({
        ...VerificationError,
        isError: true,
        errorMessage: "Verification code is required!",
      });
    } else if (VerificationCode) {
      VerificationCodeApi(userDetail?.user?.id, VerificationCode)
        .then((res) => {
          if (res.status === 200) {
            // console.log("Resp", res);
            setRequetStart(false);
            setSignUpState(!SignUpState);
            // setValidCaptcha(false);
            setVerificationCode(null);
            setEmailVerificationStatus(!EmailVerificationStatus);
            toast.success("Registration successfully ", {
              position: toast.POSITION.TOP_RIGHT,
              transition: Flip,
            });
            setUserDetail({
              ...userDetail,
              user: {
                ...userDetail.user,
                emailConfirmed: true,
              },
            });
            setAuth({
              ...userDetail,
              user: {
                ...userDetail.user,
                emailConfirmed: true,
              },
            });
            localStorage.setItem(
              "LoginSession",
              JSON.stringify({
                ...userDetail,
                user: {
                  ...userDetail.user,
                  emailConfirmed: true,
                },
              })
            );
            if (UserType === USER_TYPE.SELLLER) {
              navigate({ pathname: "/Services" }, { replace: true });
            } else navigate({ pathname: from }, { replace: true });
          }
        })
        .catch((error) => {
          if (error.response.data.text === "CODEEXPIRE") {
            setRequetStart(false);
            setVerificationError({
              ...VerificationError,
              isError: true,
              errorMessage: error?.response?.data?.key ?? "Unkonwn Error!",
              isCodeExpire: true,
            });
          } else {
            setRequetStart(false);
            setVerificationError({
              ...VerificationError,
              isError: true,
              errorMessage: error?.response?.data?.key ?? "Unkonwn Error!",
            });
          }
        });
    }
  }
  function resendVerificationCodeHandler() {
    setRequetStart(true);
    ResendVerificationCode(userDetail?.user?.id)
      .then((res) => {
        if (res.status === 200) {
          setRequetStart(false);
          // toast.success("Verification Code Sent!", {
          //   position: toast.POSITION.TOP_RIGHT,
          //   transition: Flip,
          // });
        }
      })
      .catch((error) => {});
  }
  useEffect(() => {
    if (SignUpState || SignIn) {
      disableScroll();
    } else {
      enableScroll();
    }
  }, [SignUpState, SignIn]);

  // Cleanup effect to ensure scrolling is restored on unmount
  useEffect(() => {
    return () => {
      enableScroll();
    };
  }, []);

  const handleStepChange = (newStep) => {
    dispatch(setStep(newStep));
  };

  const handleEmailStep = () => {
    setShowEmailField(true);
    setEmailStep(true);
    setPasswordStep(false);
    setShowPasswordField(false);
  };

  const handleEmailNext = (e) => {
    e.preventDefault();
    if (formik.values.email && !formik.errors.email) {
      dispatch(setField({ email: formik.values.email }));
      setShowPasswordField(true);
      setPasswordStep(true);
      setEmailStep(false);
    } else {
      formik.setFieldTouched('email', true);
    }
  };

  const handlePasswordCreate = () => {
    if (formik.values.password && !formik.errors.password) {
      dispatch(setField({ password: formik.values.password }));
      formik.handleSubmit();
    } else {
      formik.setFieldTouched('password', true);
    }
  };

  const handleBackToEmail = () => {
    setShowPasswordField(false);
    setPasswordStep(false);
    setShowEmailField(true);
    setEmailStep(true);
  };

  const handleBackToInitial = () => {
    setShowEmailField(false);
    setShowPasswordField(false);
    setEmailStep(false);
    setPasswordStep(false);
    formik.resetForm();
  };

  // Bypass handler function
  const handleBypass = (nextStep) => {
    if (nextStep === "email") {
      // Show email field
      setShowEmailField(true);
      setEmailStep(true);
      setPasswordStep(false);
      setShowPasswordField(false);
    } else if (nextStep === "password") {
      // Show password field
      setShowPasswordField(true);
      setPasswordStep(true);
      setEmailStep(false);
      setShowEmailField(false);
      // Fill email and password in formik
      formik.setFieldValue('email', 'test@example.com');
      formik.setFieldValue('password', 'TestPass123!');
      dispatch(setField({ email: 'test@example.com', password: 'TestPass123!' }));
    } else {
      // Fill in dummy data for required fields to avoid validation errors
      const dummyData = {
        email: "test@example.com",
        password: "TestPass123!",
        firstName: "Test",
        lastName: "User",
        abn: "12345678901",
        businessName: "Test Business",
        companyName: "Test Company",
        location: "Sydney, NSW",
        serviceCategoryId: "1", // Default: resolved to Plumbing when categories load (see SelectService)
        primarySkills: [1, 2, 3], // Default selected skills
        profilePicture: null,
        roleType: UserType || USER_TYPE.CUSTOMER
      };

      // Update Redux state with dummy data
      dispatch(setField(dummyData));
      
      // Set user type if moving from step 3 to step 4
      if (nextStep === 4 && !UserType) {
        setUserType(USER_TYPE.CUSTOMER); // Default to customer
      }
      
      // Move to next step
      dispatch(setStep(nextStep));
      
      // Reset sub-step states for step 1
      if (nextStep === 2) {
        setShowEmailField(false);
        setShowPasswordField(false);
        setEmailStep(false);
        setPasswordStep(false);
      }
    }
  };

  return (
    <>
      <ToastContainer autoClose={2000} />
      {SignUpState && (
        <>
          {/* Bypass Button - only show during signup */}
          <BypassButton 
            currentStep={step} 
            userType={UserType} 
            onBypass={handleBypass}
            showEmailField={showEmailField}
            showPasswordField={showPasswordField}
          />
          <Popup
            setTrigger={setSignUpState}
            modelType="SignUp"
            ShowCrossButton={ShowCrossButton}
            cross={true}
            onClose={() => {
              setSignUpState(false);
              setUserType(null);
              setShowEmailField(false);
              setEmailStep(false);
              setPasswordStep(false);
              setShowPasswordField(false);
              dispatch(setStep(1));
              handleBackToInitial();
            }}
          >
            {RequestStart && <Spinner />}
            {/* Conditional Components Starts */}
            {step === 1 && (
              <>
              <div className="overflow-auto relative flex items-center justify-center" style={{ minHeight: 'calc(100vh - 120px)' }}>
                  <div className={POPUP_FORM_CONTENT_CLASS}>
                    <Heading
                      variant={"h6"}
                      className={
                        "flex items-center justify-center text-center"
                      }
                    >
                      {!showEmailField && !showPasswordField && "Create Your account on TradesPoster"}
                      {/* {showEmailField && !showPasswordField && "Enter your email"}
                      {showPasswordField && "Create your password"} */}
                    </Heading>
                    <div className="mt-10 xl:mt-8 w-full">
                      <form>
                        {/* Email field - only show when in email step */}
                        {showEmailField && !showPasswordField && (
                          <div className="flex justify-center w-full">
                            <div className="w-full mx-auto">
                              <TextFiled
                                label={"Email"}
                                variant={"medium"}
                                fullWidth
                                type="email"
                                name="email"
                                placeholder={"Enter your email address"}
                                onChange={formik?.handleChange}
                                value={formik?.values?.email}
                                className={"bg-white autofill:bg-white border border-solid border-[#C0C0C0]"}
                                error={formik.touched.email && formik.errors.email ? formik.errors.email : null}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter') {
                                    e.preventDefault();
                                    if (formik.values.email && !formik.errors.email) {
                                      handleEmailNext(e);
                                    } else {
                                      formik.setFieldTouched('email', true);
                                    }
                                  }
                                }}
                              />
                            </div>
                          </div>
                        )}

                        {/* Password field - only show when in password step */}
                        {showPasswordField && (
                          <div className="flex justify-center w-full">
                            <div className="w-full mx-auto">
                              <label className="mb-2 block">
                                <AuxiliaryText
                                  variant={"FieldLabel"}
                                  className={"text-offblack"}
                                >
                                  Password
                                </AuxiliaryText>
                              </label>
                              <PasswordField
                                fullWidth
                                passwordtype={PasswordType}
                                setpasswordtype={setPasswordType}
                                name="password"
                                placeholder={"Create a strong password"}
                                onChange={formik?.handleChange}
                                value={formik?.values?.password}
                                error={formik.touched.password && formik.errors.password ? formik.errors.password : null}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter') {
                                    e.preventDefault();
                                    if (formik.values.password && !formik.errors.password) {
                                      handlePasswordCreate();
                                    } else {
                                      formik.setFieldTouched('password', true);
                                    }
                                  }
                                }}
                              />
                            </div>
                          </div>
                        )}

                        {/* Next button for email step */}
                        {showEmailField && !showPasswordField && (
                          <div className="flex justify-center w-full">
                            <div className="w-full mx-auto">
                              <div className="flex items-center justify-between mt-10 w-full">
                                <StepBackButton onClick={handleBackToInitial} />
                                <MainButton
                                  variant={"small"}
                                  onClick={handleEmailNext}
                                >
                                  Next
                                </MainButton>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Create button for password step */}
                        {showPasswordField && (
                          <div className="flex justify-center w-full">
                            <div className="w-full mx-auto">
                              <div className="flex items-center justify-between mt-10 w-full">
                                <StepBackButton onClick={handleBackToEmail} />
                                <MainButton
                                  variant={"small"}
                                  onClick={handlePasswordCreate}
                                >
                                  Create
                                </MainButton>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Initial buttons - only show when no fields are visible */}
                        {!showEmailField && !showPasswordField && (
                          <>
                            <div className="flex flex-col items-center justify-center">
                              <MainButton variant={"loginSignup"} className="!w-full" type="button">
                                <img src={require('../../assets/img/google-logo.png')} className="mr-3" />
                                Sign Up with Google
                              </MainButton>
                            </div>
                            <div className="flex flex-col items-center justify-center mt-3">
                              <MainButton 
                              variant={"loginSignup"} 
                              className="!w-full" onClick={handleEmailStep}>
                                <img src={require('../../assets/img/letter-icon.png')} className="group-hover:invert mr-3 -ml-1" />
                                Sign Up with Email
                              </MainButton>
                            </div>
                          </>
                        )}
                      </form>
                    </div>
                    {/* Terms and Conditions - only show in initial state */}
                    {!showEmailField && !showPasswordField && (
                      <div className="flex justify-center left-0 w-full mt-9">
                        <SpecialText
                          variant={"Caption"}
                          className="mt-auto xl:w-full text-center text-[#232A2E]"
                        >
                          By signing up, you agree to the <span
                            className="cursor-pointer underline hover:text-primaryblue"
                            onClick={() => {
                              setSignUpState(false);
                              navigate("/terms-&-conditions");
                            }}
                          >Terms</span> and <span
                          className="cursor-pointer underline hover:text-primaryblue"
                          onClick={() => {
                            setSignUpState(false);
                            navigate("/privacy-policy");
                          }}
                        >Privacy Policies</span> <br />
                        Already have an account? <span
                            className="cursor-pointer underline hover:text-primaryblue"
                            onClick={() => {
                              setSignUpState(false);
                              setSignIn(true);
                            }}
                          >Login</span>

                        </SpecialText>
                      </div>
                    )}
                  </div>
                </div>
                {/* Sign Up form UI Ends */}
              </>
            )}
            {step === 2 && (
              <>
                <Verify
                  closePopup={() => {
                    handleStepChange(3);
                    setRequetStart(false);
                  }}
                />
              </>
            )}
            {step === 3 && (
              <>
              <div className="overflow-auto relative flex items-center justify-center" style={{ minHeight: 'calc(100vh - 120px)' }}>
                <div className="tp-container-main mx-auto">
                {/* <StepBackButton onClick={() => handleStepChange(2)} /> */}
                <Heading
                  variant={"h6"}
                  className={
                    "flex items-center justify-center text-center text-offblack"
                  }
                >
                  Choose your account
                </Heading>
                <div className="mt-10 xl:mt-[60px]">
                  <div className="flex flex-col lg:flex-row justify-center items-center gap-12">
                    {/* Business */}
                    <div
                      onClick={() => setUserType(USER_TYPE.SELLLER)}
                      className={`rounded-xl flex items-center w-[350px] h-[200px] sm:w-[450px] sm:h-[200px] md:w-[500px] md:h-[220px] lg:w-[450px] lg:h-[250px] xl:w-[500px] xl:h-[250px] 2xl:w-[616px] 2xl:h-[250px] px-5 md:px-[56px] hover:cursor-pointer border border-solid border-[#C0C0C0]  ${
                        UserType === USER_TYPE.SELLLER
                          ? "bg-primaryblue text-white border-primaryblue"
                          : "bg-white text-offblack"
                      }`}
                    >
                      <div className="w-full">
                        <div className="mt-5">
                          <i className="fi fi-rs-briefcase text-[30px] xl:text-5xl 2xl:text-[50px]"></i>
                        </div>
                        <div>
                          <SecondaryHeading
                            variant={"MainParagraphHeading"}
                            className={"mt-3"}
                          >
                            I am a business
                          </SecondaryHeading>
                        </div>
                        <div className="mt-3">
                          <Paragraph
                            variant={"MainParagraph"}
                            className={
                              "h-[54px] sm:h-[52px] md:h-[38px] lg:h-[40px] xl:h-[58px] 2xl:h-[50px] overflow-hidden text-ellipsis"
                            }
                          >
                            List your services and connect with customers.
                          </Paragraph>
                        </div>
                      </div>
                    </div>
                    {/* Customer */}
                    <div
                      onClick={() => setUserType(USER_TYPE.CUSTOMER)}
                      className={`rounded-xl flex items-center w-[350px] h-[200px] sm:w-[450px] sm:h-[200px] md:w-[500px] md:h-[220px] lg:w-[450px] lg:h-[250px] xl:w-[500px] xl:h-[250px] 2xl:w-[616px] 2xl:h-[250px] px-5 md:px-[56px] hover:cursor-pointer border border-solid border-[#C0C0C0] ${
                        UserType === USER_TYPE.CUSTOMER
                          ? "bg-primaryblue text-white border-primaryblue"
                          : "bg-white text-offblack"
                      }`}
                    >
                      <div className="w-full">
                        <div className="mt-5">
                          <i className="fi fi-rs-user text-[30px] xl:text-5xl 2xl:text-[50px]"></i>
                        </div>
                        <div>
                          <SecondaryHeading
                            variant={"MainParagraphHeading"}
                            className={"mt-3"}
                          >
                            I am a customer
                          </SecondaryHeading>
                        </div>
                        <div className="mt-3">
                          <Paragraph
                            variant={"MainParagraph"}
                            className={
                              "h-[54px] sm:h-[52px] md:h-[38px] lg:h-[40px] xl:h-[58px] 2xl:h-[50px] overflow-hidden text-ellipsis"
                            }
                          >
                            Find services and connect with businesses.
                          </Paragraph>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-end mt-5 md:mt-10 w-[350px] sm:w-[450px] md:w-[500px] lg:w-[932px] xl:w-[1032px] 2xl:w-[1264px] mx-auto">
                    <MainButton
                      type="button"
                      variant={"small"}
                      onClick={() => {
                        if (UserType !== null) {
                          UpdateUserType(graphqlService, UserType)
                          // setStep(4);
                        }else{
                          toast.error("Please Choose Your Account", {
                            position: toast.POSITION.TOP_RIGHT,
                            transition: Flip,
                          });
                        }
                      }}
                    >
                      Next
                    </MainButton>
                  </div>
                </div>

                {/* <WrittenStepper
                  currentStep={step}
                  lastStep={8}
                  currentLabel={"Choose your account type"}
                  marginTop={"absolute bottom-0 left-1/2 transform -translate-x-1/2 w-full"}
                /> */}
              </div>
              </div>

              </>
            )}
            {(step === 4 || step > 4) && (
              <>
                {UserType === USER_TYPE.CUSTOMER ? (
                  <CustomerInfo
                    onClickHandler={() => {
                      setSignUpState(false);
                      setUserType(null);
                      dispatch(setStep(1));
                    }}
                  />
                ) : (
                  <BusinessInfo
                    onClickHandler={() => {
                      setSignUpState(false);
                      setUserType(null);
                      dispatch(setStep(1));
                    }}
                  />
                )}
              </>
            )}

            {/* Conditional Components Ends */}
          </Popup>
        </>
      )}
    </>
  );
};
